import { createAsyncAction } from 'redux-promise-middleware-actions';
import { addAsyncActionPostfixes } from '../utils/actionTypeCreator';
import { tneAxiosClient } from '../api/apiSettings';
import { appAreas } from '../utils/constants';

export const types = {
  ...addAsyncActionPostfixes({
    GET_OPTIONS_FILTERS: 'GET_OPTIONS_FILTERS'
  })
};

export const getOptionsForFilters = createAsyncAction(types.GET_OPTIONS_FILTERS, (part, isApprover) => {
  switch (part) {
    case appAreas.TIMESHEETS: {
      return tneAxiosClient
        .get(`/v1/${isApprover ? 'get-approver-timesheet-filter-details' : 'get-my-timesheet-filter-details'}`)
        .then((res) => res.data.Data);
    }
    case appAreas.EXPENSES: {
      return tneAxiosClient
        .get(`/v1/${isApprover ? 'get-approver-expense-filter-details' : 'get-my-expense-filter-details'}`)
        .then((res) => res.data.Data);
    }
    default:
      return [];
  }
});
